module.exports = __webpack_public_path__ + "static/img/black_infantry_archer2.ca27230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/black_infantry_archer2.png
// module id = EwMu
// module chunks = 0